// src/contexts/ToastContext.js
import React, { createContext, useContext } from 'react';

// ✅ Import from the index barrel, which re‑exports ToastProvider & useToast
// src/components/ui/Toast/index.js has: 
// export { ToastProvider, useToast } from './ToastProvider';
import { ToastProvider as BaseToastProvider, useToast as useBaseToast } from '../components/ui/Toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  return (
    <BaseToastProvider>
      {children}
    </BaseToastProvider>
  );
};

export const useToast = () => {
  // Optionally expose through your own context if you want,
  // but simplest is to just return the base hook.
  return useBaseToast();
};

export default ToastContext;
